module.exports = __webpack_public_path__ + "media/images/indicators/segHidrica-7834870aa7daf3af1eda628077b667ed.png";